export class SR
{
	/** The current season */
	public static readonly Season: number = 3;
	/** The default loading message */
	public static readonly DefaultLoading: string = "default";
}